import { IActivityHistoryItem } from "../model";
import { Spec } from "./spec";

export class PropPathSpec extends Spec<IActivityHistoryItem> {
  constructor(
    public propPath: string[],
    private value: any,
  ) {
    super();
  }

  isSatisfiedBy(context: IActivityHistoryItem): boolean {
    // Reducir el context siguiendo el path hasta llegar al valor final
    const propValue = this.propPath.reduce((acc, key) => acc?.[key], context);

    // Comparar con el valor esperado
    return propValue === this.value;
  }
}
